import React from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'

// Pages
import App from './pages/MainPage'
import LoginPage from './pages/LoginPage'
import AdminPage from './pages/admin/Admin'
import AddChoice from './pages/choice/AddChoice'
import ChoiceList from './pages/choice/ChoiceList'

import AddRajshree from './pages/rajshree/AddRajshree'
import RajshreeList from './pages/rajshree/RajshreeList'

import ChoiceCustomerReport from './pages/report/ChoiceCustomerReport'
import ChoiceWinningReport from './pages/report/ChoiceWinningReport'
import DearSingleWinningReport from './pages/report/DearSingleWinningReport'
import RajshreePunjabWinningReport from './pages/report/RajshreePunjabWinningReport'

import DearSingleResult from './pages/result/DearSingleResult'
import RajshreePunjabResult from './pages/result/RajshreePunjabResult'

import AddSingle from './pages/single/AddSingle'
import SingleList from './pages/single/SingleList'
import LiveResult from './pages/LiveResult'
import NewsPage from './pages/news/page'
import NewsDetailPage from './pages/news/news/[slug]/page'
import RegisterPage from './pages/registration/Registration'
import LotteryDashboard from './pages/lottery-dashboard/LotteryDashboard'
import PasswordChange from './pages/password-change/PasswordChange'
import AddSingleLottery from './pages/single/AddSingle'
// import { UserManagementDashboard } from './components/admin/user-management'
import './index.css'
import './App.css'
// Layout wrapper for /DearLottery
function DearLotteryLayout() {
  return <Outlet />
}

// Routes
const router = createBrowserRouter([
  { path: '/', element: <App /> },
  {
    path: '/DearLottery',
    element: <DearLotteryLayout />,
    children: [
      { path: '', element: <LoginPage /> },
      { path: 'register', element: <RegisterPage /> },

      { path: 'admin', element: <AdminPage /> },
      // { path: 'users', element: <UserManagementDashboard /> },
      
      { path: 'choice/add-choice', element: <AddChoice /> },
      { path: 'choice/choice-list', element: <ChoiceList /> }, // this
      { path: 'lottery-dashboard', element: <LotteryDashboard /> },
      { path: 'password-change', element: <PasswordChange /> },

      { path: 'rajshree/add-rajshree', element: <AddRajshree /> },
      { path: 'rajshree/rajshree-list', element: <RajshreeList /> }, 

      { path: 'report/choice-customer-report', element: <ChoiceCustomerReport /> },
      { path: 'report/choice-winning-report', element: <ChoiceWinningReport /> },
      { path: 'report/dear-single-winning-report', element: <DearSingleWinningReport /> },
      { path: 'report/rajshree-punjab-winning-report', element: <RajshreePunjabWinningReport /> },

      { path: 'result/dear-single-result', element: <DearSingleResult /> }, //this
      { path: 'result/rajshree-punjab-result', element: <RajshreePunjabResult /> }, // this

      { path: 'single/add-single', element: <AddSingleLottery /> },
      { path: 'single/single-list', element: <SingleList /> },

      { path: 'news', element: <NewsPage /> },
      { path: 'news/:slug', element: <NewsDetailPage /> },
    ],
  },
  { path: '/live-result', element: <LiveResult /> },
])

export default router
